import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import heroBg from '../assets/images/HeroBanner.png';
import memberImage from '../assets/images/aiotaman.png'; // replace with your actual image path
import { useNavigate } from 'react-router-dom';
import '../styles/AcotExecutive.css'
import '../styles/ExecutiveMembersAiota.css';
import { BookOpen, Mail, Phone } from 'lucide-react';
// import '../styles/EDCCMembers.css';

const AcotExecutiveMembers = () => {
  const [executiveMembersAcot, setExecutiveMembersAcot] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // Fetch ACOT executive members from API
  useEffect(() => {
    const fetchAcotExecutiveMembers = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_BASEURL}/getAllAcotExecutiveMemberscms`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch ACOT executive members');
        }
        
        const responseData = await response.json();
        
        // Extract the data array from the nested response structure
        const data = responseData.data || [];
        
        // Transform API data to match the existing UI structure
        const transformedMembers = data.map(member => ({
          name: member.name,
          position: member.designation,
          image: member.file_url || memberImage, // Use API image or fallback
          contact: {
            address: member.address,
            phone1: member.mobile?.toString(),
            phone2: member.telephone?.toString(),
            email: member.email_official
          }
        }));
        
        setExecutiveMembersAcot(transformedMembers);
        setError(null);
      } catch (err) {
        console.error('Error fetching ACOT executive members:', err);
        setError(err.message);
        // Fallback to empty array if error occurs
        setExecutiveMembersAcot([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAcotExecutiveMembers();
  }, []);

  const handleMemberLogin = () => {
    navigate('/member-login');
  };

  const handleEdcclogin = () => { 
    navigate('/edcc-login');
  };

  // Loading state
  if (loading) {
    return (
      <>
        <section className="hero-fixed">
          <div className="hero-content">
            <h1>All India Occupational Therapists' Association</h1>
            <div className="hero-buttons">
              <button className="glass-button" onClick={handleMemberLogin}>
                Member Login
              </button>            
              <button className="glass-button" onClick={handleEdcclogin}>Erganomic Certificate login</button>
            </div>
          </div>
        </section>
        <div className="scrollable-content">
          <div className="content-container">
            <section className="acot-executive-section">
              <Container>
                <h2 className="acot-executive-title">
                  Executive Body of All India Occupational Therapists Association(ACOT)<br />
                </h2>
                <div className="text-center">
                  <p>Loading ACOT executive members...</p>
                </div>
              </Container>
            </section>
          </div>
        </div>
      </>
    );
  }

  // Error state
  if (error) {
    return (
      <>
        <section className="hero-fixed">
          <div className="hero-content">
            <h1>All India Occupational Therapists' Association</h1>
            <div className="hero-buttons">
              <button className="glass-button" onClick={handleMemberLogin}>
                Member Login
              </button>            
              <button className="glass-button" onClick={handleEdcclogin}>Erganomic Certificate login</button>
            </div>
          </div>
        </section>
        <div className="scrollable-content">
          <div className="content-container">
            <section className="acot-executive-section">
              <Container>
                <h2 className="executive-title">
                  Executive Body of All India Occupational Therapists Association(ACOT)<br />
                </h2>
                <div className="text-center">
                  <p>Error loading ACOT executive members: {error}</p>
                  <button 
                    className="btn btn-primary" 
                    onClick={() => window.location.reload()}
                  >
                    Retry
                  </button>
                </div>
              </Container>
            </section>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
              {!tokenState && (
                <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
              )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="acot-executive-section">
            <Container>
              <h2 className="executive-title">
                Executive Body of All India Occupational Therapists Association(ACOT)<br />
              </h2>
             <Row className='five-per-row'>
  {executiveMembersAcot.length > 0 ? (
    executiveMembersAcot.map((member, index) => (
      <Col lg={2} md={4} sm={6} xs={12} key={index} className='member-col'>
        <div className="member-card-acot-exec">
          <img 
            src={member.image} 
            alt={member.name}
            onError={(e) => {
              e.target.src = memberImage; // Fallback to default image if API image fails
            }}
          />
          {member.contact && (
            <div className="overlay-acot-exec">
              {member.contact.address && (
                <p><BookOpen size={18} className='me-2' />{member.contact.address}</p>
              )}
              {member.contact.phone1 && (
                <p><Phone size={18} className='me-2' />{member.contact.phone1}</p>
              )}
              {/* {member.contact.phone2 && (
                <p><Phone size={18} className='me-2' />{member.contact.phone2}</p>
              )} */}
              {member.contact.email && (
                <p><Mail size={18} className='me-2' />{member.contact.email}</p>
              )}
            </div>
          )}
        </div>
        <div className="member-info-acot-exec">
          <strong>{member.name}</strong>
          <p>({member.position})</p>
        </div>
      </Col>
    ))
  ) : (
    <Col xs={12} className="text-center">
      <div className="no-data-message">
        <p className="text-muted">No ACOT executive members available at the moment.</p>
      </div>
    </Col>
  )}
</Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default AcotExecutiveMembers;